import api from "../../lib/api";

export interface UpdateContractRequest {
  contractNumber: number;
}
export interface UpdateContractResponse {
  status: string;
  message_type: string;
  return_url: string;
}

export default {
  updateContract(data: UpdateContractRequest) {
    return api<UpdateContractRequest, UpdateContractResponse>({
      endpoint: "contracts/cancel/web-api/cancel",
      method: "PUT",
      body: data
    });
  }
};
